// import axios from "axios";
import Cookie from "js-cookie";
// import appUrls from '../../../helpers/environment'

// function openListings() {
//     function getOpenListings() {
//         axios.get(`${appUrls.api}/api/admin/listings`, {
//             headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
//         })
//         .then( res => {
//             let aListings = [];

//             if(res.data.outcome){
//                 let all_listings = res.data.listings;
//                 //console.log(all_listings)
//                 for( let listing of all_listings ) {
//                     if( parseInt(listing.status) === 1 ) {
//                         aListings.push({ "text": listing.listing_id, "value": listing.id});
//                     }
//                 }
//             }
//             console.log(aListings)
//             return aListings;
//         })
//         .catch(function (error) {
//             console.log(error);
//         });
    
//         const listings = getOpenListings()
//         return lisitngs
//     }
// }
// const open_listings = openListings()

const fund_companies = [
    { "text": "DFA", "value": "dfa" },
    { "text": "Vanguard", "value": "vanguard" },
    { "text": "Other", "value": "other" },
]

const gross_revenue = [
    { "text": "$100,000 or less", "value": "0" },
    { "text": "$100,000 - $300,000", "value": "1" },
    { "text": "$300,001 - $500,000", "value": "2" },
    { "text": "$500,001 - $700,000", "value": "3" },
    { "text": "$700,001- $1,000,000", "value": "4" },
    { "text": "$1,000,001 - $1,500,000", "value": "5" },
    { "text": "$1,500,001 - $2,000,000", "value": "6" },
    { "text": "$2,000,001 - $2,500,000", "value": "7" },
    { "text": "$2,500,001 - $3,000,000", "value": "8" },
    { "text": "$3,000,001 - $4,000,000", "value": "9" },
    { "text": "$4,000,001 - $5,000,000", "value": "10" },
    { "text": "$5,000,001 - $6,000,000", "value": "11" },
    { "text": "$6,000,001 - $7,000,000", "value": "12" },
    { "text": "$7,000,001 - $8,000,000", "value": "13" },
    { "text": "$8,000,001 - $9,000,000", "value": "14" },
    { "text": "$9,000,001 - $10,000,000", "value": "15" },
    { "text": "$10,000,001 - $11,000,000", "value": "16" },
    { "text": "$11,000,001 - $12,000,000", "value": "17" },
    { "text": "$12,000,001 - $13,000,000", "value": "18" },
    { "text": "$13,000,001 - $14,000,000", "value": "19" },
    { "text": "$14,000,001 - $15,000,000", "value": "20" },
    { "text": "$15,000,001 - $16,000,000", "value": "21" },
    { "text": "$16,000,001 - $17,000,000", "value": "22" },
    { "text": "$17,000,001 - $18,000,000", "value": "23" },
    { "text": "$18,000,001 - $19,000,000", "value": "24" },
    { "text": "$19,000,001 - $20,000,000", "value": "25" },
    { "text": "$20,000,000+", "value": "26" }
];

const political_affiliations = [
    { "text": "Democrat", "value": "democrat" },
    { "text": "Republican", "value": "republican" },
    { "text": "Independent", "value": "independent" },
    { "text": "Decline to Answer", "value": "decline" }
];

const practice_types = [
    { text: 'Registered Representative', value: 'registered-representative'},
    { text: 'OSJ (Office of Supervisory Jurisdiction)', value: 'osj' },
    { text: 'RIA (Registered Investment Adviser) - SEC', value: 'ria-sec' },
    { text: 'RIA (Registered Investment Adviser) - State Registered', value: 'ria-state' },
    { text: 'Investment Advisor Representative', value: 'investment-advisor-representative' },
    { text: 'Insurance Agent/Agency', value: 'insurance' },
    { text: 'CPA / Tax Preparation', value: 'cpa' },
    { text: 'Other', value: 'other' }
];

const software_crm = [
    { text: 'None', value: '0' },
    { text: 'ACT!', value: '1' },
    { text: 'Contact Manager', value: '2' },
    { text: 'Junxure', value: '3' },
    { text: 'Microsoft Dynamics', value: '4' },
    { text: 'Redtail', value: '5' },
    { text: 'Salesforce', value: '6' },
    { text: 'Smart Office', value: '7' },
    { text: 'Other', value: '8' }
];

const software_financial_planning = [
    { text: 'None', value: '0' },
    { text: 'eMoney', value: '1' },
    { text: 'MoneyGuidePro', value: '2' },
    { text: 'Morningstar Advisor Workstation', value: '3' },
    { text: 'NaviPlan Select', value: '4' },
    { text: 'Proprietary', value: '5' },
    { text: 'WealthVision', value: '6' },
    { text: 'Other', value: '7' }
];

const states = [
    { "text": "Alabama", "value": "AL" },
    { "text": "Alaska", "value": "AK" },
    { "text": "Arizona", "value": "AZ" },
    { "text": "Arkansas", "value": "AR" },
    { "text": "California", "value": "CA" },
    { "text": "Colorado", "value": "CO" },
    { "text": "Connecticut", "value": "CT" },
    { "text": "Delaware", "value": "DE" },
    { "text": "District Of Columbia", "value": "DC" },
    { "text": "Florida", "value": "FL" },
    { "text": "Georgia", "value": "GA" },
    { "text": "Hawaii", "value": "HI" },
    { "text": "Idaho", "value": "ID" },
    { "text": "Illinois", "value": "IL" },
    { "text": "Indiana", "value": "IN" },
    { "text": "Iowa", "value": "IA" },
    { "text": "Kansas", "value": "KS" },
    { "text": "Kentucky", "value": "KY" },
    { "text": "Louisiana", "value": "LA" },
    { "text": "Maine", "value": "ME" },
    { "text": "Maryland", "value": "MD" },
    { "text": "Massachusetts", "value": "MA" },
    { "text": "Michigan", "value": "MI" },
    { "text": "Minnesota", "value": "MN" },
    { "text": "Mississippi", "value": "MS" },
    { "text": "Missouri", "value": "MO" },
    { "text": "Montana", "value": "MT" },
    { "text": "Nebraska", "value": "NE" },
    { "text": "Nevada", "value": "NV" },
    { "text": "New Hampshire", "value": "NH" },
    { "text": "New Jersey", "value": "NJ" },
    { "text": "New Mexico", "value": "NM" },
    { "text": "New York", "value": "NY" },
    { "text": "North Carolina", "value": "NC" },
    { "text": "North Dakota", "value": "ND" },
    { "text": "Ohio", "value": "OH" },
    { "text": "Oklahoma", "value": "OK" },
    { "text": "Oregon", "value": "OR" },
    { "text": "Pennsylvania", "value": "PA" },
    { "text": "Rhode Island", "value": "RI" },
    { "text": "South Carolina", "value": "SC" },
    { "text": "South Dakota", "value": "SD" },
    { "text": "Tennessee", "value": "TN" },
    { "text": "Texas", "value": "TX" },
    { "text": "Utah", "value": "UT" },
    { "text": "Vermont", "value": "VT" },
    { "text": "Virginia", "value": "VA" },
    { "text": "Washington", "value": "WA" },
    { "text": "West Virginia", "value": "WV" },
    { "text": "Wisconsin", "value": "WI" },
    { "text": "Wyoming", "value": "WY" }
];

const states_and_regions = [
    { "text": "All States", "value": "all-states" },
    { "text": "Northwest (WA, OR, ID", "value": "region-nw" },
    { "text": "Southwest (UT, CO, AZ, NM)", "value": "region-sw" },
    { "text": "West (CA, NV)", "value": "region-w" },
    { "text": "West North Central/Northern Rockies & Plains (MT, WY, ND, SD, NE)", "value": "region-rockies" },
    { "text": "South (TX, KS, OK, AR, LA", "value": "region-s" },
    { "text": "Upper Midwest (MN, IA, WI, MI)", "value": "region-midwest" },
    { "text": "Ohio Valley (MO, IL, IN, OH, KY, TN)", "value": "region-ohio-valley" },
    { "text": "Southeast (AL, GA, FL, SC, NC)", "value": "region-se" },
    { "text": "Mid-Atlantic (VA, WV, DC, MD, DE, NY, NJ, PA)", "value": "region-atlantic" },
    { "text": "Northeast (CT, RI, MA, VT, NH, ME)", "value": "region-ne" }
].concat(states);

const tamps = [
    { "text": "Assetmark", "value": "assetmark" },
    { "text": "SEI", "value": "sei" },
    { "text": "Envestnet", "value": "envestnet" },
    { "text": "Brinker Capital", "value": "brinker" },
    { "text": "Other", "value": "other" }
];

export {
    // fund_companies,
    // gross_revenue,
    // political_affiliations,
    // practice_types,
    // software_crm,
    // software_financial_planning,
    states,
    // states_and_regions,
    // tamps
};



// WEBPACK FOOTER //
// ./src/components/buyer/data/data.js